// Modernized SimplePay wordmark (locked).
// Mark: MICR E-13B transit symbol from Canadian cheques, redrawn with rounded
// geometry in Grey 400. Wordmark: Brand 600 green, site display typeface.
// tone: 'color' for light backgrounds, 'grey' for the dark footer.

type LogoProps = {
  tone?: 'color' | 'grey'
  className?: string
}

export default function Logo({ tone = 'color', className = 'h-7 w-auto' }: LogoProps) {
  const mark = tone === 'grey' ? '#b8c2d1' : '#6b7280'
  const word = tone === 'grey' ? '#b8c2d1' : '#16a34a'

  return (
    <svg
      viewBox="0 0 180 40"
      className={className}
      role="img"
      aria-label="SimplePay"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* transit symbol ⑆ — bar + two stacked squares */}
      <rect x="2" y="7" width="7.5" height="26" rx="2.5" fill={mark} />
      <rect x="15" y="8.5" width="9" height="9" rx="2.5" fill={mark} />
      <rect x="15" y="22.5" width="9" height="9" rx="2.5" fill={mark} />
      <text
        x="33"
        y="30"
        fontFamily="'Plus Jakarta Sans', system-ui, sans-serif"
        fontWeight={800}
        fontSize={28}
        letterSpacing="-0.5"
        fill={word}
      >
        SimplePay
      </text>
    </svg>
  )
}
